import { writeUIState } from '@bridebook/web/lib/ai-planner/epics/ui-state';
import {
  closeAIPlanner,
  openAIPlanner,
  restoreAIPlanner,
  setAIPlannerPanelOpen,
  startAIPlannerOnboarding,
  toggleAIPlanner,
} from '@bridebook/web/lib/ai-planner/slice';
import { IEpic } from '@bridebook/web/lib/types';
import { ofType } from 'redux-observable';
import { ignoreElements, tap, withLatestFrom } from 'rxjs/operators';

// Records the panel state on every change.
export const persistAIPlannerPanelEpic: IEpic = (action$, { state$ }) =>
  action$.pipe(
    ofType(
      setAIPlannerPanelOpen.type,
      openAIPlanner.type,
      restoreAIPlanner.type,
      startAIPlannerOnboarding.type,
      closeAIPlanner.type,
      toggleAIPlanner.type,
    ),
    withLatestFrom(state$),
    tap(([, state]) => writeUIState({ isPanelOpen: state.aiPlanner.isPanelOpen })),
    ignoreElements(),
  );
